var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "about-category", on: { mousemove: _vm.getCursorPosition } },
    [
      _c(
        "div",
        { staticClass: "about-category__wrapper" },
        [
          _c("BaseTitle", {
            staticClass: "about-category__title",
            attrs: { text: _vm.titleText }
          }),
          _c(
            "ul",
            { staticClass: "about-category__list" },
            _vm._l(_vm.categories, function(category, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "about-category__item",
                  on: {
                    click: function($event) {
                      return _vm.getCategoryId(++index)
                    }
                  }
                },
                [
                  _c(
                    "BaseAnimation",
                    {
                      attrs: {
                        attr: {
                          opacity: 1,
                          y: 0,
                          delay: 0.25 * index
                        }
                      }
                    },
                    [
                      _c("ShapeListLink", {
                        attrs: { item: category, index: index }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            0
          ),
          _c("AboutPageSmallAnimation", {
            attrs: { position: { x: _vm.x, y: _vm.y } }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46c1e186", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46c1e186","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/AboutCategoryBlock.vue
// module id = 4P1+
// module chunks = 2